import '../../App.css';
import Hero from '../../components/Hero/Hero';
import Panels from '../../components/Panels/Panels';
import FAQ from '../../components/FAQ/FAQ';
import SEO from '../../components/SEO/SEO';
import { useLanguage } from '../../context/LanguageContext';
import { getHomePageStructuredData, getFAQStructuredData } from '../../utils/structuredData';
import heroImage from '../../assets/hero/sentmo-thinking.svg';
import rules from '../../assets/panels/rules.svg';
import reflection from '../../assets/panels/reflection.svg';
import fundamental from '../../assets/panels/fundamental.svg';
import rulesboard from '../../assets/panels/ruleboard.svg';
import insights from '../../assets/panels/insights.svg';
import journal from '../../assets/panels/trading-journal.svg';

const Home = () => {
  const { lang, t } = useLanguage();

  const panelsData = t.problems.items.map((item, index) => ({
    title: item.title,
    description: item.description,
    image: [rules, reflection, fundamental][index]
  }));

  const panelsData2 = t.solutions.items.map((item, index) => ({
    title: item.title,
    description: item.description,
    image: [rulesboard, insights, journal][index]
  }));

  const heroData = {
    title: t.hero.title,
    description: t.hero.description,
    image: heroImage
  };

  const baseUrl = 'https://sentmo.com';

  return (
    <>
      <SEO
        title={t.seo.home.title}
        description={t.seo.home.description}
        keywords="Trading Sentiment, Sentiment Analyse, Trading Tools, Retail Trader, Trading Journal, US30, NASDAQ, S&P500, DAX, Gold"
        canonicalUrl={`${baseUrl}/${lang}`}
        lang={lang}
        alternateUrls={[
          { lang: 'de', url: `${baseUrl}/de` },
          { lang: 'en', url: `${baseUrl}/en` },
          { lang: 'x-default', url: `${baseUrl}/de` }
        ]}
        structuredData={[
          ...getHomePageStructuredData({
            lang,
            title: t.seo.home.title,
            description: t.seo.home.description
          }),
          getFAQStructuredData(t.faq.items)
        ]}
      />
      <Hero title={heroData.title} description={heroData.description} image={heroData.image} />
      <main className="content">
        <h2 className="page-title">{t.problems.title}</h2>
        <Panels panelsData={panelsData} />
        <h2 className="page-title">{t.solutions.title}</h2>
        <Panels panelsData={panelsData2} />
        <FAQ faqs={t.faq.items} title={t.faq.title} />
      </main>
    </>
  );
};

export default Home;
